import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledSectionRow = styled(StyledFlex)`
   padding: 12px 0;
   border-bottom: solid 1px ${(props) => props.theme.borderLight};
`;

StyledSectionRow.displayName = 'StyledSectionRow';
